/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-confusing-void-expression */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/display-name */
/* eslint-disable react/hook-use-state */
import React, { forwardRef, useImperativeHandle, useState } from "react";
import {
  Combobox,
  DatePicker,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Textarea,
} from "@repo/ui";
import { PREV_DAY_DATE } from "utils/constant";
import {
  useGetCustomerServicePoints,
  useGetCustomerServicePointsBySource,
  useGetRouteTeams,
} from "utils/apis/lookups.api";
import { showToast } from "utils/helper";
import { formatDate } from "date-fns";

const jobPriorities = [
  {
    id: "1",
    text: "Critical",
  },
  {
    id: "2",
    text: "High",
  },
  {
    id: "3",
    text: "Normal",
  },
  {
    id: "4",
    text: "Low",
  },
];

const jobNatures = [
  {
    id: "Normal",
    text: "Normal",
  },
  {
    id: "Adhoc",
    text: "Adhoc",
  },
  { id: "Special Service", text: "Special Service" },
];

const invoicingModels = [
  {
    id: "Fixed",
    text: "Fixed",
  },
  {
    id: "Dedicated",
    text: "Dedicated",
  },
  {
    id: "Service",
    text: "Service",
  },
];

const jobTypes = [
  { value: "Collection", name: "Collection" },
  { value: "Holding", name: "Holding" },
  { value: "Delivery", name: "Delivery" },
];

const B2BJobEditCard = forwardRef(
  (
    { request, isEdit, setIsEdit, onConfirmEdit, isReRoute = false }: any,
    ref,
  ) => {
    const [ddlSourceLocation, setDdlSourceLocation] = useState("");

    const [ddlOnwardLocation, setDdlOnwardLocation] = useState("");

    const [ddlJobPriority, setDdlJobPriority] = useState(
      jobPriorities.find((item) => item.text === request?.priority)?.id || "",
    );
    const [ddlInvoicingModels, setDdlInvoicingModel] = useState(
      request?.invoicingModel || "",
    );
    const [ddlJobNatures, setDdlJobNatures] = useState(
      request?.jobNature || "",
    );
    const [ddlJobType, setDdlJobType] = useState(request?.jobType || "");

    const [ddlInRouteTeams, setDdlInRouteTeams] = useState(
      request?.routeNo || "",
    );
    const [serviceDateTime, setServiceDateTime] = useState(
      new Date(request?.serviceDateTime || ""),
    );
    const [remarks, setRemarks] = useState(request?.remarks || "");

    const { data: sourceLocations } = useGetCustomerServicePoints(
      request?.billingCustomerId,
    );
    const { data: onwardLocations } = useGetCustomerServicePointsBySource(
      ddlSourceLocation || request?.sourceSPId || "",
    );

    const isCompleted = request?.status === "Completed";
    const { data: inRouteTeams } = useGetRouteTeams();

    const onSourceLocationChanged = (value: string) => {
      if (!value) {
        setDdlSourceLocation("");
        return;
      }

      setDdlSourceLocation(value);
    };

    const onDestinationLocationChanged = (value: string) => {
      if (!value) {
        setDdlOnwardLocation("");
        return;
      }
      setDdlOnwardLocation(value);
    };

    const onDdlInvoicingModelChanged = (value: string) => {
      if (!value) {
        setDdlInvoicingModel("");
        return;
      }

      setDdlInvoicingModel(value);
    };

    const onDdlJobNatureChanged = (value: string) => {
      if (!value) {
        setDdlJobNatures("");
        return;
      }

      setDdlJobNatures(value);
    };

    const onDdlJobPriorityChanged = (value: string) => {
      setDdlJobPriority(value);
    };

    const onDdlInRouteTeamsChanged = (value: string) => {
      if (!value) {
        setDdlInRouteTeams("");
        return;
      }

      setDdlInRouteTeams(value);
    };

    useImperativeHandle(ref, () => ({
      onBtnConfirmClicked(e: any) {
        e.stopPropagation();
        const onwardSPId = ddlOnwardLocation || request?.onwardSPId;
        const sourceSPId = ddlSourceLocation || request?.sourceSPId;

        if (sourceSPId === onwardSPId && !isReRoute) {
          showToast("error", "Source and onward location can not be same.");
          return;
        }

        const editJobDto = {
          requestId: request?.requestId,
          jobNo: request?.jobNo,
          customerId: request?.billingCustomerId,
          sourceSPId,
          onwardSPId,
          serviceDateTime: formatDate(
            serviceDateTime || new Date(),
            "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'",
          ),
          invoicingModel: ddlInvoicingModels,
          jobNature: ddlJobNatures,
          jobType: ddlJobType,
          priority: parseInt(ddlJobPriority),
          routeNo: ddlInRouteTeams,
          remarks,
        };
        setIsEdit(false);
        onConfirmEdit(editJobDto);
      },
    }));

    return (
      <>
        <div className="flex gap-3 border-b py-3 items-center">
          <div className="flex-1">
            <span className="text-sm font-medium leading-none">Order ID:</span>
          </div>
          <div className="flex-[2]">
            <span className="fw-bold">{request?.orderId}</span>
          </div>
          <div className="flex-1">
            <span className="text-sm font-medium leading-none">Job No:</span>
          </div>
          <div className="flex-[2]">
            <span className="fw-bold">{request?.jobNo}</span>
          </div>
        </div>
        <div className="flex gap-3 border-b py-3 items-center">
          <div className="flex-1">
            <span className="text-sm font-medium leading-none">
              Billing Customer:
            </span>
          </div>
          <div className="flex-[2]">{request?.billingCustomerName}</div>

          <div className="flex-1">
            <span className="text-sm font-medium leading-none">
              Invoicing Model:
            </span>
          </div>
          <div className="flex-[2]">
            {isEdit && !isCompleted ? (
              <Select
                onValueChange={onDdlInvoicingModelChanged}
                value={ddlInvoicingModels || request?.invoicingModel}
              >
                <SelectTrigger className="w-full">
                  <SelectValue placeholder="Select Invoicing Model" />
                </SelectTrigger>
                <SelectContent>
                  {invoicingModels.map((item) => (
                    <SelectItem key={item.id} value={item.id}>
                      {item.text}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            ) : (
              request?.invoicingModel
            )}
          </div>
        </div>

        <div className="flex gap-3 border-b py-3 items-center">
          <div className="flex-1">
            <span className="text-sm font-medium leading-none">
              Source Location:
            </span>
          </div>
          <div className="flex-[2]">
            {isEdit && !isCompleted ? (
              <Combobox
                value={ddlSourceLocation}
                data={sourceLocations?.map((item: any) => ({
                  label: `${item.barcode}-${item.locationId}`,
                  value: item.servicePointId,
                }))}
                placeholder="Select Source Location"
                setValue={onSourceLocationChanged}
              />
            ) : (
              request?.sourceLocationName
            )}
          </div>
          <div className="flex-1">
            <span className="text-sm font-medium leading-none">
              Onward Location:
            </span>
          </div>
          <div className="flex-[2]">
            {isEdit ? (
              <Combobox
                value={ddlOnwardLocation}
                data={onwardLocations?.map((item: any) => ({
                  label: `${item.barcode}-${item.locationId}`,
                  value: item.servicePointId,
                }))}
                placeholder="Select Onward Location"
                setValue={onDestinationLocationChanged}
              />
            ) : (
              request?.onwardLocationName
            )}
          </div>
        </div>

        <div className="flex gap-3 border-b py-3 items-center">
          <div className="flex-1">
            <span className="text-sm font-medium leading-none">
              Source Location Barcode:
            </span>
          </div>
          <div className="flex-[2]">{request?.sourceLocationBarcode}</div>
          <div className="flex-1">
            <span className="text-sm font-medium leading-none whitespace-nowrap">
              Onward Location Barcode:
            </span>
          </div>
          <div className="flex-[2]">{request?.onwardLocationBarcode}</div>
        </div>
        <div className="flex gap-3 border-b py-3 items-center">
          <div className="flex-1">
            <span className="text-sm font-medium leading-none">
              Source Location Id:
            </span>
          </div>
          <div className="flex-[2]">{request?.sourceLocationId}</div>
          <div className="flex-1">
            <span className="text-sm font-medium leading-none whitespace-nowrap">
              Onward Location Id:
            </span>
          </div>
          <div className="flex-[2]">{request?.onwardLocationId}</div>
        </div>

        <div className="flex gap-3 border-b py-3 items-center">
          <div className="flex-1">
            <span className="text-sm font-medium leading-none">
              Job Nature:
            </span>
          </div>
          <div className="flex-[2]">
            {isEdit && !isCompleted ? (
              <Select
                onValueChange={onDdlJobNatureChanged}
                value={ddlJobNatures}
              >
                <SelectTrigger className="w-full">
                  <SelectValue placeholder="Select Job Nature" />
                </SelectTrigger>
                <SelectContent>
                  {jobNatures.map((item) => (
                    <SelectItem key={item.id} value={item.id}>
                      {item.text}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            ) : (
              request?.jobNature
            )}
          </div>
          <div className="flex-1">
            <span className="text-sm font-medium leading-none">
              Job Priority:
            </span>
          </div>
          <div className="flex-[2]">
            {isEdit && !isCompleted ? (
              <Select
                onValueChange={onDdlJobPriorityChanged}
                value={ddlJobPriority}
              >
                <SelectTrigger className="w-full">
                  <SelectValue placeholder="Select Job Priority" />
                </SelectTrigger>
                <SelectContent>
                  {jobPriorities.map((item) => (
                    <SelectItem key={item.id} value={item.id}>
                      {item.text}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            ) : (
              request?.priority
            )}
          </div>
        </div>

        <div className="flex gap-3 border-b py-3 items-center">
          <div className="flex-1">
            <span className="text-sm font-medium leading-none">Route No:</span>
          </div>
          <div className="flex-[2]">
            {isEdit && !isCompleted ? (
              <Combobox
                data={inRouteTeams?.map((m) => ({
                  value: m.routeNo,
                  label: `${m.routeNo} (${m.description})`,
                }))}
                value={ddlInRouteTeams}
                placeholder="Select Route"
                setValue={onDdlInRouteTeamsChanged}
              />
            ) : (
              request?.routeNo
            )}
          </div>
          <div className="flex-1">
            <span className="text-sm font-medium leading-none">
              Service Date & Time:
            </span>
          </div>
          <div className="flex-[2]">
            {(isEdit && !isCompleted) || (isEdit && isReRoute) ? (
              <DatePicker
                selectedDate={serviceDateTime}
                onSelectDate={setServiceDateTime}
                disabled={(date) => date < PREV_DAY_DATE}
              />
            ) : (
              request?.serviceDateTime
            )}
          </div>
        </div>
        <div className="flex  gap-3 border-b py-3">
          <div className="flex-1">
            <span className="text-sm font-medium leading-none">Status:</span>
          </div>
          <div className="flex-[2]">
            <span className="fw-bold">{request?.status}</span>
          </div>
          <div className="flex-1">
            <span className="text-sm font-medium leading-none">
              Pending Reasons:
            </span>
          </div>
          <div className="flex-[2]">
            <span className="fw-bold">{request?.pendingReason}</span>
          </div>
        </div>
        <div className="flex  gap-3 border-b py-3">
          <div className="flex-1">
            <span className="text-sm font-medium leading-none">
              Customer Type:
            </span>
          </div>
          <div className="flex-[2]">
            <span className="fw-bold">{request?.customerType}</span>
          </div>
          <div className="flex-1">
            <span className="text-sm font-medium leading-none">
              Create Date & Time:
            </span>
          </div>
          <div className="flex-[2]">
            <span className="fw-bold">{request?.createDateTime}</span>
          </div>
        </div>
        <div className="flex border-b py-3">
          <div className="flex-1">
            <span className="text-sm font-medium leading-none">
              Requested By:
            </span>
          </div>
          <div className="flex-[2]">
            <span className="fw-bold">{request?.requestedBy}</span>
          </div>
          <div className="flex-1">
            <span className="text-sm font-medium leading-none">Job Type:</span>
          </div>
          <div className="flex-[2]">
            {isEdit && !isCompleted ? (
              <Select onValueChange={setDdlJobType} value={ddlJobType}>
                <SelectTrigger className="w-full">
                  <SelectValue placeholder="Select Job Type" />
                </SelectTrigger>
                <SelectContent>
                  {jobTypes.map((item) => (
                    <SelectItem key={item.value} value={item.value}>
                      {item.name}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            ) : (
              request?.jobType
            )}
          </div>
        </div>
        <div className="flex border-b py-3">
          <div className="flex-1">
            <span className="text-sm font-medium leading-none">Remarks:</span>
          </div>
          <div className="flex-[2]">
            {isEdit && !isCompleted ? (
              <Textarea
                className="w-full"
                value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
              />
            ) : (
              request?.remarks
            )}
          </div>
          <div className="flex-1">
            <span className="text-sm font-medium leading-none">FieldTeam:</span>
          </div>
          <div className="flex-[2]">
            <span className="fw-bold">{request?.fieldTeam}</span>
          </div>
        </div>
      </>
    );
  },
);

export default B2BJobEditCard;
